import { get, map } from 'lodash';
import axios from 'axios';

export const handleS3Upload = async (
	policyResponse: {
		success?: boolean;
		policy?: any;
		data?: any;
		filePath?: string;
		errorMessage?: string;
	},
	blob: Blob,
) => {
	if (!policyResponse.success) {
		// show error
		throw new Error('Failed to get policy');
	}

	const url = get(policyResponse.policy, 'url');
	const endpoint = `${url}/${policyResponse.filePath}`;

	const formData = new FormData();
	map(policyResponse.policy.fields, (value, key) => {
		formData.append(key, value);
	});

	formData.append('file', blob);
	const response = await axios.post(url, formData);
	if (response.status === 204) {
		return endpoint;
	}
};
